import appConfig from '@/config';

export const NO_CONFIG_URLS = [
  appConfig.s3Url,
  'https://api.twilio.com',
  'https://sisense.rentsync.dev',
  'https://sisense.rentsync.com',
  'https://vimeo.com/',
  'https://api.autoenhance.ai',
  'https://autoenhanceapi-prod.s3.eu-west-1.amazonaws.com',
  'https://autoenhanceapi-prod.s3.amazonaws.com',
  'https://autoenhanceapi-prod.s3-accelerate.amazonaws.com',
];

export const NO_SITE_ID_PATHS = [
  '/website-api/maintenance_forms',
  '/website-api/panel_template_groups',
  '/website-api/panel_template',
  '/website-api/waitinglists',
];

export const OTHER_PATHS_NEEDING_SITE_ID = [
  '/property-api/regions',
  '/property-api/cities-offered',
  '/property-api/panels',
  '/property-api/custom-fields',
  '/custom-content/panels',
  '/custom-content/pages',
  '/custom-content/bios',
  '/custom-content/blog',
  '/custom-content/careers',
  '/custom-content/news',
  '/custom-content/cities_offered',
];

export const TIMEOUT_URLS = [
  `${appConfig?.adminGateway}/auth/current-user`,
];

/**
 * Configuration for HTML decoding via Axios response middleware.
 *
 * - `path` supports either a RegExp or a string (matched against the request URL)
 * - `methods` must explicitly list the HTTP methods to apply decoding for
 * - `fields` defines which response properties should be decoded
 * - Fields support dot-notation for nested properties (e.g. 'buildingType.name')
 * - Array fields are supported using `[]` and dot-notation (e.g. 'ownershipGroups[].name')
 * - Supports both single objects and arrays of objects
 *
 * ⚠️ If a decoded field may be later sent back via PUT or POST,
 * make sure a corresponding encoding rule exists in `HTML_ENCODE_CONFIG`
 * to prevent persisting decoded values.
 */

export const HTML_DECODE_CONFIG = [
  {
    path: /property-api\/properties\/relations\/\d+$/,
    methods: ['GET'],
    fields: [
      'buildingName',
      'buildingOverview',
      'locationDetails',
      'officeHours',
    ],
  },
  {
    path: '/property-api/properties/client-settings',
    methods: ['GET'],
    fields: [
      'ownershipGroups[].name',
    ],
  },
];

/**
 * Configuration for HTML encoding via Axios request middleware.
 *
 * - `path` supports either a RegExp or a string (matched against the request URL)
 * - `methods` must explicitly list the HTTP methods to apply encoding for
 * - `fields` defines which request properties should be encoded before sending
 * - Fields support dot-notation for nested properties (e.g. 'buildingType.name')
 * - Array fields are supported using `[]` and dot-notation (e.g. 'ownershipGroups[].name')
 * - Supports both single objects and arrays of objects
 *
 */
export const HTML_ENCODE_CONFIG = [
  {
    path: /property-api\/properties\/\d+$/,
    methods: ['PUT'],
    // Didn't include buildingOverview and locationDetails because
    // the input tiptap component they are in automatically encodes them
    fields: [
      'buildingName',
      'officeHours',
    ],
  },
];
